class ShareButton extends HTMLElement {
  private mainDetailsToggle: HTMLDetailsElement | null = null
  private closeButton: HTMLButtonElement | null = null
  private urlToShare: string = ''

  private initialized = false

  connectedCallback(): void {
    if (this.initialized) return
    this.initialized = true

    this.mainDetailsToggle = this.querySelector('details')
    if (!this.mainDetailsToggle) return

    this.urlToShare = this.dataset.shareUrl ?? document.location.href

    this.closeButton = this.querySelector<HTMLButtonElement>('.share-button__close')
    const copyButton = this.querySelector<HTMLButtonElement>('.share-button__copy')

    this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this))
    copyButton?.addEventListener('click', this.copyToClipboard.bind(this))
    this.closeButton?.addEventListener('click', this.close.bind(this))
  }

  private toggleDetails(): void {
    if (!this.mainDetailsToggle?.open) {
      this.querySelector('[id^="ShareMessage"]')?.classList.add('hidden')
      this.closeButton?.classList.add('hidden')
    }
  }

  private copyToClipboard(): void {
    navigator.clipboard.writeText(this.urlToShare).then(() => {
      const message = this.querySelector('[id^="ShareMessage"]')
      if (!message) return
      message.textContent = (window as any).accessibilityStrings?.shareSuccess ?? 'Link copied'
      message.classList.remove('hidden')
      this.closeButton?.classList.remove('hidden')
    }).catch(() => {
      const input = this.querySelector<HTMLInputElement>('input')
      if (!input) return
      input.select()
      document.execCommand('copy')
    })
  }

  updateUrl(url: string): void {
    this.urlToShare = url
    const input = this.querySelector<HTMLInputElement>('input')
    if (input) input.value = url
  }

  close(): void {
    this.mainDetailsToggle?.removeAttribute('open')
    this.mainDetailsToggle?.querySelector('summary')?.focus()
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton)
}

export default ShareButton
